import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from "prop-types";
import { EuiFocusTrap } from '../../../../src/components/focus_trap';
import { EuiButton } from '../../../../src/components/button';
export var GuideFullScreen = ({
  children,
  isFullScreen = false,
  buttonText = 'Show fullscreen demo',
  onOpen
}) => {
  const [fullScreen, setFullScreen] = useState(isFullScreen); // Watch for fullScreen status and appropriately add/remove body classes for hiding scroll

  useEffect(() => {
    if (fullScreen) {
      document.body.classList.add('guideBody--overflowHidden');
    }

    return () => {
      document.body.classList.remove('guideBody--overflowHidden');
    };
  }, [fullScreen]);

  const openFullScreen = () => {
    setFullScreen(true);

    if (onOpen) {
      onOpen();
    }
  };

  return <Fragment>
      <EuiButton onClick={openFullScreen} iconType="fullScreen">
        {buttonText}
      </EuiButton>

      {fullScreen && <div className="guideFullScreenOverlay">
          <EuiFocusTrap>{children(setFullScreen)}</EuiFocusTrap>
        </div>}
    </Fragment>;
};
GuideFullScreen.propTypes = {
  children: PropTypes.func.isRequired,
  buttonText: PropTypes.node,
  isFullScreen: PropTypes.bool,
  onOpen: PropTypes.func
};

try {
  GuideFullScreen.__docgenInfo = {
    description: '',
    displayName: 'GuideFullScreen',
    methods: [],
    props: {
      buttonText: {
        defaultValue: {
          value: 'Show fullscreen demo'
        },
        description: '',
        name: 'buttonText',
        parent: undefined,
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      isFullScreen: {
        defaultValue: {
          value: 'false'
        },
        description: '',
        name: 'isFullScreen',
        parent: undefined,
        required: false,
        type: {
          name: 'boolean'
        }
      },
      onOpen: {
        defaultValue: null,
        description: '',
        name: 'onOpen',
        parent: undefined,
        required: false,
        type: {
          name: '() => void'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}